/*
 * @Author: 李朋飞
 * @Date: 2021-12-17 14:06:25
 * @LastEditTime: 2021-12-17 14:06:26
 * @Description: 
 */
import FormPanel from './FormPanel';

export default {
  install(Vue) {
    Vue.component('FormPanel', FormPanel);
  }
};


// WEBPACK FOOTER //
// ./src/components/FormPanel/index.js